var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37475 5.25102C9.03 5.25102 8.75 4.91765 8.75 4.50727V1.73177L12.0243 5.25102H9.37475ZM9.625 14H4.375C3.892 14 3.5 13.608 3.5 13.125C3.5 12.642 3.892 12.25 4.375 12.25H9.625C10.1089 12.25 10.5 12.642 10.5 13.125C10.5 13.608 10.1089 14 9.625 14ZM4.375 8.75H7C7.483 8.75 7.875 9.142 7.875 9.625C7.875 10.108 7.483 10.5 7 10.5H4.375C3.892 10.5 3.5 10.108 3.5 9.625C3.5 9.142 3.892 8.75 4.375 8.75ZM13.7725 4.662L9.884 0.287C9.71862 0.104125 9.48325 0 9.2365 0H2.2365C1.00362 0 0 0.98175 0 2.1875V15.3125C0 16.5182 1.00362 17.5 2.2365 17.5H11.7635C12.9973 17.5 14 16.5182 14 15.3125V5.25C14 5.03212 13.9186 4.823 13.7725 4.662Z",
    fill: "url(#paint0_linear_42_3546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_3546",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0053F4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon1);
export default __webpack_public_path__ + "static/media/InvoiceIcon1.d7b9f1002058935f114f3c626e9167e5.svg";
export { ForwardRef as ReactComponent };